import { useEffect, useState } from 'react';
import accountApis from '../../../../../services/accountApis';
import { IGetPackageHistoryTopUpResponse } from '../types';
import { AxiosResponse } from 'axios';

const useGetPackageHistoryTopUp = (shopId: string, isLazy = false) => {
  const [page, setPage] = useState(1);
  const [data, setData] = useState<IGetPackageHistoryTopUpResponse>();
  const [loading, setLoading] = useState<boolean>(false);

  const mutate = async (params: { page: number, size: number }) => {
    setLoading(true);
    try {
      const res: AxiosResponse<{ data: IGetPackageHistoryTopUpResponse }> = await accountApis.getSMSPackageHistoryTopUp(shopId, params.page, params.size);
      setData(res?.data?.data);
    } catch (error) {
      console.error('Error fetching SMS package history top-up:', error);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (!isLazy && shopId) {
      mutate({ page: 1, size: 10 });
    }

    return () => {
      setData(undefined);
      setPage(1);
    };
  }, [shopId]);

  return { page, setPage, data, loading, mutate };
};

export default useGetPackageHistoryTopUp;
